import { render, staticRenderFns } from "./vSidebar.vue?vue&type=template&id=04841851&scoped=true&"
import script from "./vSidebar.vue?vue&type=script&lang=js&"
export * from "./vSidebar.vue?vue&type=script&lang=js&"
import style0 from "./vSidebar.vue?vue&type=style&index=0&id=04841851&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04841851",
  null
  
)

export default component.exports